
<template>
  <a-drawer
    :title="title"
    placement="right"
    :width="600"
    :closable="false"
    :visible="visible"
    @close="handleClose"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="科目编码">
        <a-input
          v-decorator="[
            'subNo',
            { rules: [{ required: true, message: '科目编码不能为空!' }] },
          ]"
          placeholder="请输入科目编码"
        />
      </a-form-item>
      <a-form-item label="科目名称">
        <a-input
          v-decorator="[
            'subName',
            { rules: [{ required: true, message: '科目名称不能为空!' }] },
          ]"
          placeholder="请输入科目名称"
        />
      </a-form-item>
      <a-form-item label="科目类型">
        <a-input
            v-decorator="[
            'subType',
          ]"
        />
      </a-form-item>
      <a-form-item label="会计科目适用范围">
        <a-input
            v-decorator="[
            'subArea',
          ]"
        />
      </a-form-item>
<!--      <a-form-item label="税务科目编码">-->
<!--        <a-input-->
<!--            v-decorator="[-->
<!--            'taxDecNo',-->
<!--          ]"-->
<!--        />-->
<!--      </a-form-item>-->

<!--      <a-form-item label="税务科目名称">-->
<!--        <a-input-->
<!--            v-decorator="[-->
<!--            'taxSubName',-->
<!--          ]"-->
<!--        />-->
<!--      </a-form-item>-->

<!--      <a-form-item label="年度余额取值">-->
<!--        <a-input-->
<!--            v-decorator="[-->
<!--            'yearCol',-->
<!--          ]"-->
<!--        />-->
<!--      </a-form-item>-->

<!--      <a-form-item label="季度余额取值">-->
<!--        <a-input-->
<!--            v-decorator="[-->
<!--            'quarCol',-->
<!--          ]"-->
<!--        />-->
<!--      </a-form-item>-->
<!--      <a-form-item label="月度余额取值">-->
<!--        <a-input-->
<!--            v-decorator="[-->
<!--            'monthCol',-->
<!--          ]"-->
<!--        />-->
<!--      </a-form-item>-->
    </a-form>
    <div
      :style="{
        position: 'absolute',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'right',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
      }"
    >
      <a-button style="margin-right: 8px" @click="handleClose">取消</a-button>
      <a-button type="primary" @click="handleSave">确定</a-button>
    </div>
  </a-drawer>
</template>
<script>
import pick from "lodash.pick";
import { createSubject,updateSubject } from "@/api/subject";
export default {
  name: "userModal",
  data() {
    return {
      status: 1,
      visible: false,
      record: {},
      form: this.$form.createForm(this, { name: "form" }),
      confirmLoading: false,
      loadedKeys: [],
      treeData: [],
      roleList: [],
      positionList: [],
    };
  },
  methods: {
    onLoad(loadedKeys) {
      this.loadedKeys = loadedKeys;
    },
    async show(status, record) {
      this.status = status;
      this.visible = true;
      if (record) {
        let that = this;
        that.record = record;
        that.$nextTick(() => {
          that.form.setFieldsValue(
            pick(
              record,
              "subNo",
              "subName",
              "subType",
               "subArea",
              "taxDecNo",
              "taxSubName",
              "yearCol",
              "monthCol",
                "quarCol",
            )
          );
        });
      }
    },
    handleSave() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let res;
          if (this.status == 2) {
            res = await createSubject(values);
          } else {
            res = await   updateSubject(Object.assign(this.record, values));
          }
          if (res.status == 200) {
            this.visible = false;
            this.$message.success(this.status == 2 ? "创建成功" : "修改成功");
            this.$emit("reload");
          } else {
            this.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        }
      });
    },
    handleClose() {
      this.form.resetFields();
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped></style>
